import "./AutoShare.css";
// import { setLoading } from "../../../../redux/loading/loadingSlice";
import { toastify } from "../../../../helpers/toast/toastify";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState, useRef } from "react";
import check from "../../../../assets/images/check.svg";
import discord from "../../../../assets/images/discord.svg";
import FloatingDropdownWithArrow from "../../CommonComponents/FloatingDropdownWithArrow/FloatingDropdownWithArrow";
import FloatingSelectField from "../../CommonComponents/FloatingSelectField/FloatingSelectField";
import FloatingTextFiled from "../../CommonComponents/FloatingTextFiled/FloatingTextFiled";
import InfoPopup from "../../CommonComponents/InfoPopup/InfoPopup";
import telegram from "../../../../assets/images/telegram.jpg";
import useApi from "../../../../helpers/apiHelper/requestHelper";
import xIcon from "../../../../assets/images/x.jpg";
import BubbleSvgButton from "../../CommonComponents/BubbleSvgButton/BubbleSvgButton";
import ConfirmModal from "../../CommonComponents/ConfirmModal/ConfirmModal";
import VerificationApiModal from "../ExchangeConnection/VerificationApiModal";
import { fetchUser } from "../../../../helpers/helper";
import { storeUser } from "../../../../redux/users/usersSlice";
import { setRefetchSpecificUser } from "../../../../redux/multicommunity/multicommunity";

const AutoShare = ({
  title = "Share your trade entries and results",
  subtitle = "Select the channels to automatically share to",
  customClass = ""
}) => {
  const api = useApi();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.user);
  // const loading = useSelector((state) => state?.loader?.isLoading || false);
  const [connectLoading, setConnectLoading] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);
  const [disconnectLoading, setDisconnectLoading] = useState(false);

  const [connectedSocial, setConnectedSocial] = useState("");
  const [discordData, setDiscordData] = useState({
    channelName: "",
    serverId: "",
  });
  const [formErrors, setFormErrors] = useState({
    channelName: false,
    chatId: false,
    serverId: false,
  });
  const [isConnected, setIsConnected] = useState(false);
  const [shareTradingResultAs, setShareTradingResultAs] = useState("");
  const [shareTradingResultTime, setShareTradingResultTime] = useState("");
  const [showChannelName, setShowChannelName] = useState(false);
  const [showDisconnectButton, setShowDisconnectButton] = useState(false);
  const [showSaveButton, setShowSaveButton] = useState(false);
  const [showSharedOrders, setShowSharedOrders] = useState(false);
  const [showSharedResultsAs, setShowSharedResultsAs] = useState(false);
  const [showDisconnectConfirmation, setShowDisconnectConfirmation] = useState({
    show: false,
    buttonClick: "Disconnect",
  });
  const [showRedirectWarning, setShowRedirectWarning] = useState(false);
  const [socialChannelVaue, selectedSocialChannel] = useState("");
  const [telegramData, setTelegramData] = useState({ chatId: "" });
  const userIdRef = useRef(null);

  // Reset component state when user changes
  useEffect(() => {
    const currentUserId = user?._id || user?.id;
    
    // If user ID has changed, reset all state
    if (userIdRef.current !== null && userIdRef.current !== currentUserId) {
      setConnectedSocial("");
      setDiscordData({ channelName: "", serverId: "" });
      setIsConnected(false);
      setShareTradingResultAs("");
      setShareTradingResultTime("");
      setShowChannelName(false);
      setShowDisconnectButton(false);
      setShowSaveButton(false);
      setShowSharedOrders(false);
      setShowSharedResultsAs(false);
      selectedSocialChannel("");
      setTelegramData({ chatId: "" });
      // connectedSocialChannel();
    }
    
    // Update the ref with current user ID
    userIdRef.current = currentUserId;
  }, [user]);
  const connectedSocialChannel = () => {
    // Check if the same value is being selected and if it's already connected
    const isDiscordConnected = 
      user?.leaderCommunity?.socials?.discordServerId && 
      user?.leaderCommunity?.socials?.discordChannelName;
    const isTelegramConnected = 
      user?.leaderCommunity?.socials?.telegramChatId;
    const isXConnected = 
      user?.leaderCommunity?.socials?.twitterCodeVerifier&&user?.leaderCommunity?.socials?.twitterRefreshToken;
    
    const isAlreadyConnected = isDiscordConnected || isTelegramConnected || isXConnected;
    const connectedSocial = isDiscordConnected ? "Discord" : isTelegramConnected ? "Telegram" : isXConnected ? "X" : "";
    // If selecting the same value and it's already connected, don't reset state
    if (!isAlreadyConnected) {
      return;
    }
    
    selectedSocialChannel(connectedSocial);
    setConnectedSocial("");
    setDiscordData({ channelName: "", serverId: "" });
    setIsConnected(false);
    setShareTradingResultAs("");
    setShareTradingResultTime("");
    setShowChannelName(false);
    setShowDisconnectButton(false);
    setShowSaveButton(false);
    setShowSharedOrders(false);
    setShowSharedResultsAs(false);
    setTelegramData({ chatId: "" });
  };
  useEffect(()=>{
  connectedSocialChannel()
  },[user])

  const handleSocialChannelChange = (value) => {
    // Check if the same value is being selected and if it's already connected
    const isDiscordConnected = value === "Discord" && 
      user?.leaderCommunity?.socials?.discordServerId && 
      user?.leaderCommunity?.socials?.discordChannelName;
    const isTelegramConnected = value === "Telegram" && 
      user?.leaderCommunity?.socials?.telegramChatId;
    const isXConnected = value === "X" && 
      user?.leaderCommunity?.socials?.twitterCodeVerifier&&user?.leaderCommunity?.socials?.twitterRefreshToken;
    
    const isAlreadyConnected = isDiscordConnected || isTelegramConnected || isXConnected;
    
    // If selecting the same value and it's already connected, don't reset state
    if (value === socialChannelVaue && isAlreadyConnected) {
      return;
    }
    
    selectedSocialChannel(value);
    setConnectedSocial("");
    setDiscordData({ channelName: "", serverId: "" });
    setIsConnected(false);
    setShareTradingResultAs("");
    setShareTradingResultTime("");
    setShowChannelName(false);
    setShowDisconnectButton(false);
    setShowSaveButton(false);
    setShowSharedOrders(false);
    setShowSharedResultsAs(false);
    setTelegramData({ chatId: "" });
  };

  const handleDiscordButtonClick = () => {
    const discordOAuthURL =
      "https://discord.com/api/oauth2/authorize?client_id=1275052346581323936&permissions=3089&scope=bot";

    window.open(discordOAuthURL, "_blank");
  };

  const handleTelegramButtonClick = () => {
    const CopyyyItBotURL = "https://t.me/CopyTrading_Results_bot";
    // const CopyyyItBotURL = "https://t.me/MyCopyBot_dev_bot";


    window.open(CopyyyItBotURL, "_blank");
  };

  const proceedToSocialConnect = () => {
    if (socialChannelVaue === "Discord") {
      handleDiscordButtonClick();
    } else if (socialChannelVaue === "Telegram") {
      handleTelegramButtonClick();
    } else if (socialChannelVaue === "X") {
      handleTwitterButtonClick();
    }
    setIsConnected(true);
    setConnectedSocial(socialChannelVaue);
    setShowRedirectWarning(false);
  };

  const handleTwitterButtonClick = async () => {
    setConnectLoading(true);

    try {
      localStorage.setItem("twitter", "true");

      if (user?.twitterCodeVerifier && user?.twitterRefreshToken) {
        toastify("You have already Authorized with Twitter.", "error");
        return;
      }

      const response = await api("get", "social/twitterOAuth");

      if (response?.status) {
        window.open(response?.data?.url);
        toastify(response?.message, "success");
      } else {
        toastify(response?.message, "error");
      }
    } catch (error) {
      toastify(error?.message || "Twitter connection failed", "error");
    } finally {
      setConnectLoading(false);
    }
  };

  const handleServerIdChange = (e) => {
    const newServerId = e.target.value;

    setDiscordData({
      ...discordData,
      serverId: newServerId,
    });
    setShowChannelName(newServerId.trim() !== "");
  };

  const handleChannelNameChange = (e) => {
    const newChannelName = e.target.value;

    setDiscordData({
      ...discordData,
      channelName: newChannelName,
    });
    setShowSharedOrders(showChannelName && newChannelName.trim() !== "");
  };

  const handleChatIdChange = (e) => {
    const newChatId = e.target.value;

    setTelegramData({
      ...telegramData,
      chatId: newChatId,
    });
    setShowSharedOrders(newChatId.trim() !== "");
  };

  const handleSharedOrdersChange = (value) => {
    setShareTradingResultTime(value);
    setShowSharedResultsAs(value !== "");
  };

  const handleSharedResultsAsChange = (value) => {
    setShareTradingResultAs(value);
    setShowSaveButton(value !== "");
  };

  const handleSaveButton = async () => {
    setSaveLoading(true);

    try {
      if (connectedSocial === "Discord") {
        await saveDiscord();
      } else if (connectedSocial === "Telegram") {
        await saveTelegram();
      }

      const response = await api(
        "post",
        "copyTrade/update-message-permissions",
        {
          isCloseOrdersOnly: shareTradingResultTime?.toLowerCase() === "close",
          platform: connectedSocial.toLowerCase()=== "x" ? "twitter" : connectedSocial?.toLowerCase(),
          sendAsText: shareTradingResultAs?.toLowerCase() === "text",
        }
      );

      if (response?.status) {
        await fetchUser(api, dispatch, storeUser);
        setShowSaveButton(false);
        toastify(response?.message, "success");
      } else {
        toastify(response?.message, "error");
      }
    } catch (error) {
      toastify(error?.message || "Failed to save settings", "error");
    } finally {
      setSaveLoading(false);
    }
  };

  const saveDiscord = async () => {
    if (!discordData?.channelName) {
      toastify("Channel name is missing.", "error");
      throw new Error("Channel name missing");
    }

    if (!discordData?.serverId) {
      toastify("Server ID is missing.", "error");
      throw new Error("Server ID missing");
    }

    try {
      const requestBody = {
        communityId: user?.leaderCommunity?._id,
        name: discordData?.channelName,
        serverId: discordData?.serverId,
      };

      const response = await api(
        "post",
        "social/createDiscordChannel",
        requestBody
      );

      if (response?.status) {
        await fetchUser(api, dispatch, storeUser);

        setDiscordData({ serverId: "", channelName: "" });
      } else {
        throw new Error(response?.message);
      }
    } catch (error) {
      throw error;
    }
  };

  const saveTelegram = async () => {
    if (!telegramData?.chatId) {
      toastify("Chat id is missing.", "error");
      throw new Error("Chat ID missing");
    }

    try {
      const requestBody = {
        chatId: telegramData?.chatId,
        communityId: user?.leaderCommunity?._id,
      };

      const response = await api("post", "social/verifyTelegram", requestBody);

      if (response?.status) {
        await fetchUser(api, dispatch, storeUser);

        setTelegramData({ chatId: "" });
      } else {
        throw new Error(response?.message);
      }
    } catch (error) {
      throw error;
    }
  };

  const handleSocialReset = async (platform) => {
    setDisconnectLoading(true);

    try {
      const apiPlatform =
        platform?.toLowerCase() === "x" ? "twitter" : platform?.toLowerCase();
      const response = await api("post", "social/reset", {
        platform: apiPlatform,
      });
      if (response?.status) {
        await fetchUser(api, dispatch, storeUser);
        handleSocialChannelChange("");
        toastify(`${platform} disconnected successfully!`, "success");
      } else {
        toastify(response?.message || "Failed to disconnect", "error");
      }
    } finally {
      setDisconnectLoading(false);
    }
  };

  useEffect(() => {
    if (user?.leaderCommunity?.socials) {
      const socials = user.leaderCommunity.socials;

      if (socials.discordServerId && socials.discordChannelName) {
        setDiscordData({
          channelName: socials.discordChannelName,
          serverId: socials.discordServerId,
        });

        if (socialChannelVaue === "Discord") {
          setConnectedSocial("Discord");
          setIsConnected(true);
          setShowChannelName(true);
          setShowDisconnectButton(true);
          setShowSharedOrders(true);

          if (user?.messagePermissions?.discord) {
            const userDiscordPermissions = user.messagePermissions.discord;

            setShareTradingResultAs(
              userDiscordPermissions.sendAsText ? "Text" : "Image"
            );
            setShareTradingResultTime(
              userDiscordPermissions.isCloseOrdersOnly
                ? "Close"
                : "Open & Close"
            );
            setShowSharedResultsAs(true);
          }
        }
      }

      if (socials.telegramChatId) {
        setTelegramData({
          chatId: socials.telegramChatId,
        });

        if (socialChannelVaue === "Telegram") {
          setConnectedSocial("Telegram");
          setIsConnected(true);
          setShowDisconnectButton(true);
          setShowSharedOrders(true);

          if (user?.messagePermissions?.telegram) {
            const userTelegramPermissions = user.messagePermissions.telegram;

            setShareTradingResultAs(
              userTelegramPermissions.sendAsText ? "Text" : "Image"
            );
            setShareTradingResultTime(
              userTelegramPermissions.isCloseOrdersOnly
                ? "Close"
                : "Open & Close"
            );
            setShowSharedResultsAs(true);
          }
        }
      }

      if (socials.twitterCodeVerifier) {
        if (socialChannelVaue === "X") {
          setConnectedSocial("X");
          // if(socials.twitterAuthorized)
          if(socials.twitterRefreshToken&&socials?.twitterAuthorized){
            setShowDisconnectButton(true);
          }
          
          if (user?.messagePermissions?.twitter&&socials.twitterRefreshToken) {
            setIsConnected(true);
            const twitterPermissions = user.messagePermissions.twitter;
            setShowSharedOrders(true);

            setShareTradingResultAs(
              twitterPermissions.sendAsText ? "Text" : "Image"
            );
            setShareTradingResultTime(
              twitterPermissions.isCloseOrdersOnly ? "Close" : "Open & Close"
            );
            setShowSharedResultsAs(true);
            if(!socials?.twitterAuthorized){
              setShowSaveButton(true);
            }
          }
        }
      }
    }
  }, [socialChannelVaue, user]);

  return (
    <>
      <div className={`AutoShareSection ${customClass}`} id="AutoShare">
        <div className="row align-items-start mb-d sm-md-15">
          <div className="col-lg-6 col-md-6 col-12">
            <div className="titleWrapper">
              <p className="title">{title}</p>
              <InfoPopup
                contentItems={[
                  {
                    type: "heading",
                    text: "Share your trade entries + results",
                  },
                  {
                    type: "paragraph",
                    text: "Connect the socials you want us to automatically share your results to.",
                  },
                ]}
              />
            </div>
            <p className="subTitle">
              {subtitle}
            </p>
          </div>
          <div className="col-lg-6 col-md-6 col-12">
            <div className="connectedChannelBox mb-lg-0 mb-md-0">
              {(discordData?.serverId ||
                telegramData?.chatId ||
                user?.leaderCommunity?.socials?.twitterCodeVerifier) && (
                <p className="">Sharing to:</p>
              )}
              {discordData?.serverId && <img alt="discord" src={discord} />}
              {telegramData?.chatId && <img alt="telegram" src={telegram} />}
              {user?.leaderCommunity?.socials?.twitterCodeVerifier&&user?.leaderCommunity?.socials?.twitterAuthorized && (
                <img alt="xIcon" src={xIcon} />
              )}
            </div>
          </div>
        </div>
        <div className="grid-row justify-content-start">
          <div className={`grid-col ${!socialChannelVaue ? "grid-col--expanded" : ""}`}>
            <div className="fixedWidth1440">
              <FloatingDropdownWithArrow
                id="socialChannelDropdown"
                label="Select Social Channel"
                options={["Discord", "Telegram", "X"]}
                selectedValue={socialChannelVaue}
                setSelectedValue={handleSocialChannelChange}
              />
            </div>
          </div>

          <div className="grid-col autoShareControlCol">
            <div className="fixedWidth1440 mx-auto">
              {socialChannelVaue && !showDisconnectButton && (
                <BubbleSvgButton
                  onClick={() => {
                    // OLD: connected immediately without warning the user about the 3rd-party redirect
                    // if (socialChannelVaue === "Discord") {
                    //   handleDiscordButtonClick();
                    // } else if (socialChannelVaue === "Telegram") {
                    //   handleTelegramButtonClick();
                    // } else if (socialChannelVaue === "X") {
                    //   handleTwitterButtonClick();
                    // }
                    // setIsConnected(true);
                    // setConnectedSocial(socialChannelVaue);
                    setShowRedirectWarning(true);
                  }}
                  text={connectLoading ? "Connecting" : "Connect"}
                  disabled={connectLoading || saveLoading}
                  type="button"
                  variant="black"
                  svgIcon={
                    isConnected ? (
                      <img
                        alt="connected icon"
                        src={check}
                        style={{
                          width: "21px",
                          height: "21px",
                        }}
                      />
                    ) : null
                  } // Set to null when not connected
                  svgPosition={isConnected ? "right" : null}
                  containerStyling={{
                    justifyContent: "center",
                  }}
                />
              )}
              {showDisconnectButton && (
                <BubbleSvgButton
                  onClick={() =>
                    setShowDisconnectConfirmation({
                      show: true,
                      buttonClick: "Disconnect",
                      type: "social",
                    })
                  }
                  text={"Disconnect"}
                  disabled={disconnectLoading}
                  type="button"
                  variant="red"
                  containerStyling={{
                    justifyContent: "center",
                  }}
                />
              )}
            </div>
          </div>
          {connectedSocial === "Discord" && (
            <>
              <div className="grid-col autoShareControlCol">
                <div className="fixedWidth1440 textFielRemoveShadow mx-auto">
                  <FloatingTextFiled
                    className={formErrors["serverId"] ? "invalid" : ""}
                    disabled={showDisconnectButton}
                    label="Server ID"
                    onChange={handleServerIdChange}
                    placeholder="Server ID"
                    value={discordData.serverId}
                    focusedAllowed={false}
                  />
                </div>
              </div>
              {showChannelName && (
                <div className="grid-col autoShareControlCol">
                  <div className="textFielRemoveShadow fixedWidth1440 ms-auto">
                    <FloatingTextFiled
                      disabled={showDisconnectButton}
                      forLabel="monthly-price"
                      id="monthly-price"
                      label="Channel Name"
                      onChange={handleChannelNameChange}
                      placeholder="Channel Name"
                      value={discordData.channelName}
                      focusedAllowed={false}
                    />
                  </div>
                </div>
              )}
            </>
          )}
          {connectedSocial === "Telegram" && (
            <div className="grid-col autoShareControlCol">
              <div className="textFielRemoveShadow fixedWidth1440 ms-auto">
                <FloatingTextFiled
                  className={formErrors["chatId"] ? "invalid" : ""}
                  disabled={showDisconnectButton}
                  label="Chat ID"
                  onChange={handleChatIdChange}
                  placeholder="Chat ID"
                  value={telegramData.chatId}
                  focusedAllowed={false}
                />
              </div>
            </div>
          )}
          {/* {showSharedOrders && <div className="w-100"></div>} */}
          {showSharedOrders && (
            <div className="grid-col autoShareControlCol">
              <div
                className={`fixedWidth1440 ${
                  socialChannelVaue === "X" && "mx-auto"
                } ${socialChannelVaue === "Telegram" && "ms-auto"}`}
              >
                {/* <FloatingDropdownWithArrow id="SharedOrdersDropdown" label="Orders to share" options={["Close", "Open & Close"]} disabled={showDisconnectButton} selectedValue={shareTradingResultTime} setSelectedValue={handleSharedOrdersChange} /> */}
                <FloatingSelectField
                  id="SharedOrdersDropdown"
                  label="Orders to share"
                  options={["Close", "Open & Close"]}
                  disabled={showDisconnectButton}
                  value={shareTradingResultTime}
                  onChange={(e) => handleSharedOrdersChange(e.target.value)}
                  focusedAllowed={false}
                />
              </div>
            </div>
          )}
          {showSharedResultsAs && (
            <div className="grid-col autoShareControlCol">
              <div
                className={`fixedWidth1440 ${
                  socialChannelVaue === "X" ? "ms-auto" : "mx-auto"
                }
                ${socialChannelVaue === "Telegram" && "me-auto"}`}
              >
                {/* <FloatingDropdownWithArrow id="SharedAsDropdown" label="Select format to share" disabled={showDisconnectButton} options={socialChannelVaue === "X" ? ["Text"] : ["Text", "Image"]} selectedValue={shareTradingResultAs} setSelectedValue={handleSharedResultsAsChange} /> */}
                <FloatingSelectField
                  id="SharedAsDropdown"
                  label="Select format to share"
                  disabled={showDisconnectButton}
                  options={socialChannelVaue === "X" ? ["Text"] : ["Text", "Image"]}
                  value={shareTradingResultAs}
                  onChange={(e) => handleSharedResultsAsChange(e.target.value)}
                  focusedAllowed={false}
                />
              </div>
            </div>
          )}
          {showSaveButton && (
            <div
              className={`grid-col autoShareControlCol autoShareSaveCol ${
                socialChannelVaue === "X"
                  ? "offset-lg-9 offset-md-4"
                  : "offset-lg-3 offset-md-8"
              }
              ${
                socialChannelVaue === "Telegram"
                  ? "offset-lg-6"
                  : "offset-lg-3 offset-md-8"
              }`}
            >
              <div className="fixedWidth1440 ms-auto">
                <BubbleSvgButton
                  onClick={handleSaveButton}
                  disabled={saveLoading}
                  isLoading={saveLoading}
                  text={"Save"}
                  type="button"
                  variant="green"
                  containerStyling={{
                    justifyContent: "center",
                  }}
                />
              </div>
            </div>
          )}
        </div>
      </div>

      <VerificationApiModal
        showDisConnectPopup={showDisconnectConfirmation}
        onClose={() =>
          setShowDisconnectConfirmation({ show: false, buttonClick: "" })
        }
        disConnectYesAction={() => {
          handleSocialReset(socialChannelVaue);
          setShowDisconnectConfirmation({ show: false, buttonClick: "" });
        }}
      />

      <ConfirmModal
        show={showRedirectWarning}
        onHide={() => setShowRedirectWarning(false)}
        title="You'll be redirected to 3rd party."
        description="Return to this window to finish setup once you've authorised connection to your social channel."
        confirmText="Continue"
        onConfirm={proceedToSocialConnect}
      />
    </>
  );
};

export default AutoShare;
